import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import {
  CountryDto,
  StateDto,
  LgaDto,
  ProjectTypeDto,
  ProjectCategoryDto,
  ClusterDto,
  ClusterCommunityDto,
  OilBlockDto,
  OilFieldDto,
  CommunityDto,
  DocumentCategoryDto,
  DocumentSubCategoryDto,
  GMOUDto,
  ProjectDto,
} from "@cradua/data";
import {
  FormBuilder,
  FormGroup,
  Validators,
  FormControl,
} from "@angular/forms";

@Component({
  selector: "mrsoftapps-register-gmou",
  templateUrl: "./register-gmou.component.html",
  styleUrls: ["./register-gmou.component.scss"],
})
export class RegisterGmouComponent implements OnInit {
  @Input()
  states: StateDto[];
  @Input()
  lgas: LgaDto[];
  @Input()
  projectTypes: ProjectTypeDto[];
  @Input()
  projectCategories: ProjectCategoryDto[];
  @Input()
  projectData: GMOUDto;
  @Input()
  oilBlocks: OilBlockDto[];
  @Input()
  oilFields: OilFieldDto[];

  @Input()
  gmous: GMOUDto[];
  @Output()
  changeEmit = new EventEmitter<any>();
  @Output()
  taskEmit = new EventEmitter<any>();
  toppings = new FormControl();

  oilfieldsFormCtrl = new FormControl();
  gmouForm: FormGroup;
  multipleLgas: LgaDto[];
  multipleOilFields: OilFieldDto[];
  genericLabel;
  constructor(private fb: FormBuilder) {}

  ngOnInit() {
    this.getGmouForm();
  }

  getGmouForm() {
    this.gmouForm = this.fb.group({
      GMOUTypeId: ["", Validators.required],
      GMOUCategoryId: [""],
      NegotiationDate: [""],
      SignatureDate: [""],
      GMOUTitle: ["", Validators.required],
      OilBlocId: [""],
      OilFieldId: [""],
      StateId: [""],
      LGAId: [""],
      GMOUDescription: [""],
    });
    if (this.oilFields.length > 0) {
      this.genericLabel = this.oilFields[0].LabelName;
    }
  }

  /* Handle form errors in Angular 8 */
  public errorHandling = (control: string, error: string) => {
    return this.gmouForm.controls[control].hasError(error);
  };

  onClick(value: LgaDto[]) {
    this.multipleLgas = value;
  }

  onClickOilField(value: OilFieldDto[]) {
    this.multipleOilFields = value;
    // console.log('mappppp ', this.multipleOilFields );
  }

  getState(): string | null {
    const transformLga = this.multipleLgas.map((item) => {
      return item.StateId;
    });
    const selectedState = this.states.filter((item) =>
      transformLga.includes(item.id)
    );
    const transformState = selectedState
      .map((item) => {
        return item.id;
      })
      .join(",");

    if (!transformState) {
      return null;
    }
    return transformState;
  }

  getOilBlock(): string | null {
    const transformOilFields = this.multipleOilFields.map((item) => {
      return item.OilBlockId;
    });
    const selectedOilBlocks = this.oilBlocks.filter((item) =>
      transformOilFields.includes(item.id)
    );
    const transformOilBlock = selectedOilBlocks
      .map((item) => {
        return item.id;
      })
      .join(",");

    if (!transformOilBlock) {
      return null;
    }
    return transformOilBlock;
  }

  getProjectCategory(id) {
    const selectedType = this.projectTypes.find((item) => item.id === id);
    if (!selectedType) {
      return;
    }

    const selectedCategory = this.projectCategories.find(
      (item) => item.id === selectedType.ProjectCategoryId,
    );

    if (!selectedCategory) {
      return;
    }

    return selectedCategory;
  }

  onSubmit(formValue: GMOUDto) {
    const transformLga = this.multipleLgas
      .map((item) => {
        return item.id;
      })
      .join(",");
    const transformOilField = this.multipleOilFields
      .map((item) => {
        return item.id;
      })
      .join(",");

    const selectedState = this.getState();
    const selectedProjectType = this.getProjectCategory(formValue.GMOUTypeId);
    const selectedOilField = this.getOilBlock();
    formValue.LGAId = transformLga;
    formValue.OilFieldId = transformOilField;
    formValue.StateId = selectedState;
    formValue.GMOUCategoryId = selectedProjectType.id;
    formValue.OilBlocId = selectedOilField;
    this.changeEmit.emit(formValue);
    // console.log('transform ', formValue)
  }
}
